import React, { useEffect, useState } from 'react';
import { CustomTable } from 'src/components/atoms';
import { HeaderGlobal, Breadcrumb } from 'src/components';
import { Doughnut, Bar, Line } from 'react-chartjs-2';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { setDataDataset } from 'src/config/redux/action';

import L from 'leaflet';
import { MapContainer, TileLayer, GeoJSON, useMap, LayersControl } from 'react-leaflet';
import marker from "leaflet/dist/images/marker-icon.png";
import marker2x from "leaflet/dist/images/marker-icon-2x.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import { useDispatch, useSelector } from 'react-redux';
import { DynamicMapLayer } from 'react-esri-leaflet';
import MarkerClusterGroup from 'react-leaflet-markercluster';

import * as WMS from "leaflet.wms";
import { setDataPritinjauGrafik } from 'src/config/redux/action/datasetAction';
import { ILGrafik } from 'src/assets/image';
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
    iconRetinaUrl: marker2x,
    iconUrl: marker,
    shadowUrl: markerShadow
});


const postionMap = { lat: -1.044592, lng: 119.925741 };

const LihatDetailData = ({ match, crumbs }) => {
    var PARAMIdLihat = match.params.idlihat;
    const [gayaGrafik, setGayaGrafik] = useState("Bar Chart");
    const [labelGayaGrafik, setLabelGayaGrafik] = useState("Bar Chart");
    const [axisA, setAxisA] = useState(false);
    const [axisB, setAxisB] = useState(false);
    const {
        dataDetailDataset,
        dataDataset,
        dataSpasialTabelGeoserver,
        dataSpasialTabelArcgis,
        dataSpasialShp,
        dataSpasialTabelShp,
        dataSpasialGeoJson,
        dataSpasialTabelGeoJson,
        dataTabelJson,
        dataSpasialGeoserver,
        dataGrafikAxisA,
        dataGrafikAxisB,
        dataGrafikResult
    } = useSelector(state => state.datasetReducer);
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setDataDataset(PARAMIdLihat))
        window.scrollTo({ top: 0, behavior: "smooth" })
    }, [dispatch])


    const handleEachFeatureShp = (feature, layer) => {
        var html = "";
        Object.keys(feature.properties).map((v, i) => {
            html += `<b>${v.replace(/_/g, ' ').toUpperCase()}</b> : ${feature.properties[v]} <br />`;
        })
        layer.bindPopup(`${html}`)
    }

    const btnGrafik = () => {
        setGayaGrafik(labelGayaGrafik)
        dispatch(setDataPritinjauGrafik(axisA, axisB, labelGayaGrafik, dataDetailDataset.data))
    }


    return (
        <div className="site-main">
            <HeaderGlobal />
            <section className="ttm-row aboutus-section clearfix">
                <div className="container-xl mt-4 res-767-mt-0">

                    {/* BREADCUMB */}
                    <Breadcrumb crumbs={crumbs} />
                    {/* BREADCUMB */}

                    {
                        dataDataset &&
                        <div className="row">
                            <div className="col-md-12">
                                <div className="featured-imagebox featured-imagebox-blog style2 mb-10">
                                    <div className="row">
                                        <div className="my-3 col-md-12">
                                            <div className="col-md-12 text-justify">
                                                <h4 className="panton-bold title">{dataDataset.DataHeaderName}</h4>
                                                (Terakhir Diperbarui : {dataDataset.DataHeaderLastUpdate})
                                                <p>{dataDataset.DatasetDescription}</p>
                                                {
                                                    dataDataset.DatasetType !== 'URL Service Spasial' ?
                                                        dataDataset.DataHeaderUrlData !== null &&
                                                        <a href={dataDataset.DataHeaderUrlData} target="_blank" className="ttm-btn ttm-bgcolor-skincolor ttm-btn-size-sm">
                                                            <i className="fa fa-download" /> Unduh Data
                                                        </a>
                                                        : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12">
                                <div className="ttm-tabs tabs-for-single-products mt-2">
                                    <Tabs>
                                        <TabList>
                                            <Tab><span>Data</span></Tab>
                                            {
                                                dataDataset.DatasetType === 'Excel' && <Tab><span>Grafik</span></Tab>
                                            }
                                            {
                                                dataDataset.DatasetType === 'URL Service Spasial' && <Tab><span>Peta</span></Tab>
                                            }
                                            {
                                                dataDataset.DatasetType === 'File SHP (ZIP)' && <Tab><span>Peta</span></Tab>
                                            }
                                            {
                                                dataDataset.DatasetType === 'GeoJson' && <Tab><span>Peta</span></Tab>
                                            }
                                        </TabList>
                                        <div className="content-tab">
                                            <TabPanel>
                                                <div className="content-inner">
                                                    <div className="widget tagcloud-widget">
                                                        <h2> Data </h2>
                                                        {
                                                            dataDetailDataset &&
                                                            <div className="featured-imagebox featured-imagebox-blog style2">
                                                                <CustomTable
                                                                    columns={dataDetailDataset.columns}
                                                                    data={dataDetailDataset.data}
                                                                    title={
                                                                        <span style={{ color: '#3C4B64' }}>TABEL DATA </span>
                                                                    }
                                                                />
                                                            </div>
                                                        }
                                                        {
                                                            dataDataset.GeoportalType === 'arcgisserver' &&
                                                            <>
                                                                <div className="featured-imagebox featured-imagebox-blog style2">
                                                                    <CustomTable
                                                                        columns={dataSpasialTabelArcgis.columns}
                                                                        data={dataSpasialTabelArcgis.data}
                                                                        title={
                                                                            <span style={{ color: '#3C4B64' }}>TABEL DATA </span>
                                                                        }
                                                                    />
                                                                </div>
                                                            </>
                                                        }
                                                        {
                                                            dataDataset.DatasetType === 'File SHP (ZIP)' &&
                                                                dataSpasialTabelShp ?
                                                                <div className="featured-imagebox featured-imagebox-blog style2">
                                                                    <CustomTable
                                                                        columns={dataSpasialTabelShp.columns}
                                                                        data={dataSpasialTabelShp.data}
                                                                        title={
                                                                            <span style={{ color: '#3C4B64' }}>TABEL DATA </span>
                                                                        }
                                                                    />
                                                                </div>
                                                                : null
                                                        }
                                                        {
                                                            dataDataset.GeoportalType === 'geoserver' &&
                                                            <div className="featured-imagebox featured-imagebox-blog style2">
                                                                <CustomTable
                                                                    columns={dataSpasialTabelGeoserver.columns}
                                                                    data={dataSpasialTabelGeoserver.data}
                                                                    title={
                                                                        <span style={{ color: '#3C4B64' }}>TABEL DATA </span>
                                                                    }
                                                                />
                                                            </div>
                                                        }
                                                        {
                                                            dataDataset.DatasetType === 'Dokumen (PDF)' &&
                                                            <iframe src={`${dataDataset.DataHeaderUrlData}?p=${new Date().getTime()}`} style={{ width: '100%', height: 550, marginBottom: 20 }} />
                                                        }
                                                        {
                                                            dataDataset.DatasetType === 'GeoJson' &&
                                                            dataSpasialTabelGeoJson &&
                                                            <div className="featured-imagebox featured-imagebox-blog style2">
                                                                <CustomTable
                                                                    columns={dataSpasialTabelGeoJson.columns}
                                                                    data={dataSpasialTabelGeoJson.data}
                                                                    title={
                                                                        <span style={{ color: '#3C4B64' }}>TABEL DATA </span>
                                                                    }
                                                                />
                                                            </div>
                                                        }
                                                        {
                                                            dataDataset.DatasetType === 'Json' &&
                                                            dataTabelJson &&
                                                            <div className="featured-imagebox featured-imagebox-blog style2">
                                                                <CustomTable
                                                                    columns={dataTabelJson.columns}
                                                                    data={dataTabelJson.data}
                                                                    title={
                                                                        <span style={{ color: '#3C4B64' }}>TABEL DATA </span>
                                                                    }
                                                                />
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </TabPanel>
                                            {
                                                dataDataset.DatasetType === 'Excel' &&
                                                <TabPanel>
                                                    <div className="content-inner">
                                                        <h2> Grafik </h2>
                                                        <div className="row">
                                                            <div className="col-md-8">
                                                                <div className="featured-imagebox featured-imagebox-blog style2">
                                                                    {
                                                                        dataGrafikResult ?
                                                                            gayaGrafik === "Bar Chart" ?
                                                                                <Bar
                                                                                    data={dataGrafikResult}
                                                                                    width={100}
                                                                                    height={300}
                                                                                    options={{
                                                                                        maintainAspectRatio: false
                                                                                    }}
                                                                                />
                                                                            : gayaGrafik === 'Doughnut' ?
                                                                                <Doughnut data={dataGrafikResult} />
                                                                                :
                                                                                <Line options={{responsive: true}} data={dataGrafikResult} />
                                                                            :
                                                                            <center>
                                                                                <img className="author-img img-fluid" src={ILGrafik} style={{ width: 500 }} />
                                                                            </center>
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="featured-imagebox featured-imagebox-blog style2 ttm-bgcolor-grey">
                                                                    <form id="ttm-quote-form" className="row ttm-quote-form clearfix" method="post" action="#">
                                                                        <div className="col-sm-12 col-md-12">
                                                                            <label>Gaya Grafik</label>
                                                                            <div className="form-group">
                                                                                <select name="GayaGrafik" className="form-control bg-white" onChange={(e) => setLabelGayaGrafik(e.target.value)}>
                                                                                    <option value="Bar Chart">Bar Chart</option>
                                                                                    <option value="Line Chart">Line Chart</option>
                                                                                    <option value="Doughnut">Doughnut</option>
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-sm-12 col-md-12">
                                                                            <label>Axis X</label>
                                                                            <div className="form-group">
                                                                                <select name="AxisX" className="form-control bg-white" onChange={(e) => setAxisA(e.target.value)}>
                                                                                    <option>- Pilih -</option>
                                                                                    {
                                                                                        dataGrafikAxisA &&
                                                                                        dataGrafikAxisA.map((v, i) => {
                                                                                            return (
                                                                                                <option key={i} value={v.value}>{v.label}</option>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-sm-12 col-md-12">
                                                                            <label>Axis Y</label>
                                                                            <div className="form-group">
                                                                                <select name="AxisY" className="form-control bg-white" onChange={(e) => setAxisB(e.target.value)}>
                                                                                    <option>- Pilih -</option>
                                                                                    {
                                                                                        dataGrafikAxisB &&
                                                                                        dataGrafikAxisB.map((v, i) => {
                                                                                            return (
                                                                                                <option key={i} value={v.value}>{v.label}</option>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                         <div className="col-md-12">
                                                                            <button type="button" onClick={() => btnGrafik()} id="submit" className="mt-3 ttm-btn ttm-btn-size-md ttm-bgcolor-skincolor">
                                                                                Pritinjau
                                                                            </button>
                                                                        </div>
                                                                    </form>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                            }
                                            <TabPanel>
                                                <div className="content-inner">
                                                    <h2> Peta </h2>
                                                    {
                                                        dataDataset.GeoportalType === 'arcgisserver' &&
                                                        <div className="featured-imagebox featured-imagebox-blog style2 mb-10">
                                                            <MapContainer
                                                                id="mapId"
                                                                zoom={7}
                                                                center={postionMap}
                                                            >
                                                                    <LayersControl position="topright">
                                                                        
                                                                        <LayersControl.BaseLayer name="Google Maps" checked>
                                                                            <TileLayer
                                                                                attribution='&copy; <a href="http://osm.org/copyright">Google Maps</a> contributors'
                                                                                url="https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}"
                                                                            />
                                                                        </LayersControl.BaseLayer>
                                                                        <LayersControl.BaseLayer name="World Imagery">
                                                                            <TileLayer
                                                                                attribution='&copy; <a href="http://osm.org/copyright">World Imagery</a> contributors'
                                                                                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png"
                                                                            />
                                                                        </LayersControl.BaseLayer>

                                                                    </LayersControl>
                                                                    <DynamicMapLayer url={`${dataDataset.UrlGeoportal}/${dataDataset.LayerName}/MapServer`} />
                                                            </MapContainer>
                                                        </div>
                                                    }
                                                    {
                                                        dataDataset.GeoportalType === 'geoserver' &&
                                                        <div className="featured-imagebox featured-imagebox-blog style2 mb-10">
                                                            <MapContainer
                                                                id="mapId"
                                                                zoom={7}
                                                                center={postionMap}
                                                                className={'custom-popup-wms'}
                                                            >
                                                                <LayersControl position="topright">
                                                                    
                                                                    <LayersControl.BaseLayer name="Google Maps" checked>
                                                                        <TileLayer
                                                                            attribution='&copy; <a href="http://osm.org/copyright">Google Maps</a> contributors'
                                                                            url="https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}"
                                                                        />
                                                                    </LayersControl.BaseLayer>
                                                                    <LayersControl.BaseLayer name="World Imagery">
                                                                        <TileLayer
                                                                            attribution='&copy; <a href="http://osm.org/copyright">World Imagery</a> contributors'
                                                                            url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png"
                                                                        />
                                                                    </LayersControl.BaseLayer>

                                                                </LayersControl>

                                                                <MarkerClusterGroup showCoverageOnHover={false}>
                                                                    {
                                                                        dataSpasialGeoserver &&
                                                                        <GeoJSON
                                                                            key={`${new Date().getTime()}`}
                                                                            data={dataSpasialGeoserver}
                                                                            onEachFeature={handleEachFeatureShp}
                                                                            color='#2d6625'
                                                                            fillColor='#fdf3cd'
                                                                        />
                                                                    }
                                                                </MarkerClusterGroup>
                                                            </MapContainer>
                                                        </div>
                                                    }
                                                    {
                                                        dataDataset.DatasetType === 'File SHP (ZIP)' &&
                                                        <div className="featured-imagebox featured-imagebox-blog style2 mb-10">
                                                            <MapContainer
                                                                id="mapId"
                                                                zoom={7}
                                                                center={postionMap}
                                                            >
                                                                <LayersControl position="topright">
                                                                    
                                                                    <LayersControl.BaseLayer name="Google Maps" checked>
                                                                        <TileLayer
                                                                            attribution='&copy; <a href="http://osm.org/copyright">Google Maps</a> contributors'
                                                                            url="https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}"
                                                                        />
                                                                    </LayersControl.BaseLayer>
                                                                    <LayersControl.BaseLayer name="World Imagery">
                                                                        <TileLayer
                                                                            attribution='&copy; <a href="http://osm.org/copyright">World Imagery</a> contributors'
                                                                            url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png"
                                                                        />
                                                                    </LayersControl.BaseLayer>

                                                                </LayersControl>
                                                               
                                                                <MarkerClusterGroup showCoverageOnHover={false}>
                                                                    {
                                                                        dataSpasialShp &&
                                                                        <GeoJSON
                                                                            key={`${new Date().getTime()}`}
                                                                            data={dataSpasialShp}
                                                                            onEachFeature={handleEachFeatureShp}
                                                                            color='#2d6625'
                                                                            fillColor='#fdf3cd'
                                                                        />
                                                                    }
                                                                </MarkerClusterGroup>
                                                            </MapContainer>
                                                        </div>
                                                    }
                                                    {
                                                        dataDataset.DatasetType === 'GeoJson' &&
                                                        <div className="featured-imagebox featured-imagebox-blog style2 mb-10">
                                                            <MapContainer
                                                                id="mapId"
                                                                zoom={7}
                                                                center={postionMap}
                                                            >
                                                                <LayersControl position="topright">
                                                                    
                                                                    <LayersControl.BaseLayer name="Google Maps" checked>
                                                                        <TileLayer
                                                                            attribution='&copy; <a href="http://osm.org/copyright">Google Maps</a> contributors'
                                                                            url="https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}"
                                                                        />
                                                                    </LayersControl.BaseLayer>
                                                                    <LayersControl.BaseLayer name="World Imagery">
                                                                        <TileLayer
                                                                            attribution='&copy; <a href="http://osm.org/copyright">World Imagery</a> contributors'
                                                                            url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png"
                                                                        />
                                                                    </LayersControl.BaseLayer>

                                                                </LayersControl>
                                                                <MarkerClusterGroup showCoverageOnHover={false}>
                                                                    {
                                                                        dataSpasialGeoJson &&
                                                                        <GeoJSON
                                                                            key={`${new Date().getTime()}`}
                                                                            data={dataSpasialGeoJson}
                                                                            onEachFeature={handleEachFeatureShp}
                                                                            color='#2770c1'
                                                                            fillColor='#a7d9f0'
                                                                        />
                                                                    }
                                                                </MarkerClusterGroup>
                                                            </MapContainer>
                                                        </div>
                                                    }
                                                </div>
                                            </TabPanel>

                                        </div>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                    }

                </div>
            </section>

        </div>
    )
}

export default LihatDetailData;